import { useTier } from "../hooks/useTier";

export default function HeaderBar({
  activeBandName,
  canGenerateInvite,
  tenantContext,
  inviteCopied,
  isGeneratingInvite,
  onGenerateInvite,
  onShowUpgrade,
  onLogout,
  error,
}) {
  const { canInviteMembers } = useTier(tenantContext);

  return (
    <header className="flex h-14 flex-shrink-0 items-center gap-3 border-b border-border bg-canvas px-5">
      <span style={{ fontFamily: 'var(--font-display)', fontSize: '1.4rem', letterSpacing: '0.2em', textTransform: 'uppercase', color: '#c8a84b', fontWeight: 50 }}>
        Band OS
      </span>

      {activeBandName && (
        <span className="text-sm">{activeBandName}</span>
      )}

      <div className="flex-1" />

      {canGenerateInvite && (
        <button
          onClick={canInviteMembers ? onGenerateInvite : onShowUpgrade}
          title="Generate and copy invite token"
          disabled={isGeneratingInvite}
          className={`rounded border border-border px-2.5 py-1 text-[11px] tracking-[0.08em] ${
            inviteCopied ? "bg-accent/15 text-accent" : "bg-transparent text-text-muted"
          }`}
        >
          {isGeneratingInvite
            ? "Generating..."
            : inviteCopied
              ? "Invite Copied!"
              : "Generate Invite"}
        </button>
      )}

      <button
        onClick={onLogout}
        className="border-border text-xs text-text-muted hover:text-text-primary"
      >
        Logout
      </button>

      {error && <span className="text-xs text-danger">{error}</span>}
    </header>
  );
}
